import type { VideoSpecResponse } from "./videoSpecResponse";

export const isRaaSResponseCacheHit = (raasResponse: VideoSpecResponse): boolean => {
    //until will have an explicit way of identify raas cache, we will apply the logic bellow
    return raasResponse.persist && raasResponse._links["video-stream"].href.includes("cloudfront"); 
};
